import { createContext, useContext, useState } from "react"
import translations from "./translations"

const LanguageContext = createContext(null)

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "vi")

  function switchLang(newLang) {
    setLang(newLang)
    localStorage.setItem("lang", newLang)
  }

  // t(key) — returns the translated string; falls back to EN then the key itself
  function t(key) {
    return (
      translations[lang]?.[key] ??
      translations["en"]?.[key] ??
      key
    )
  }

  return (
    <LanguageContext.Provider value={{ lang, setLang: switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error("useLanguage must be used inside <LanguageProvider>")
  return ctx
}
